import { RouteProps } from "react-router-dom";
import { loadPortalConfig } from "features/shared/helpers/modules";

// import pages (modules)
import RequirementEmailVerification from 'features/requirements/RequirementEmailVerification';
import CustomerAccountRegistration from "features/registration/CustomerAccountRegistration";
import ContractingNew from "features/contracting/ContractingNew";

// load configuration
const portalConfig = loadPortalConfig();

// internal unauthorized routes
let _unauthorizedRoutes: RouteProps[] = [];

// helpers
const addUnauthorizedRoute = (route: RouteProps, isEnabledRoute?: () => boolean) => { 
  if (isEnabledRoute) {
    if (isEnabledRoute()) {
      _unauthorizedRoutes.push(route);
    }
  } else {
    _unauthorizedRoutes.push(route);
  }
}

// adding unauthorized routes
addUnauthorizedRoute({ exact: true, path: "/requirements/check-email", component: RequirementEmailVerification }, () => portalConfig.useFullRequirements);
addUnauthorizedRoute({ exact: true, path: "/registration/customer-account", component: CustomerAccountRegistration }, () => portalConfig.enableCustomerAccountRegistration);
addUnauthorizedRoute({ exact: false, path: "/contracting/new", component: ContractingNew }, () => portalConfig.enableContracting);

// module export
export const unauthorizedRoutes: RouteProps[] = [..._unauthorizedRoutes];

export const isUnathorizedRoute = (routePath: string) => {
  if (unauthorizedRoutes.find(x => determineUnathorizeRoute(x, routePath)) !== undefined) {
    return true;
  }
}

const determineUnathorizeRoute = (defineRoute: RouteProps, actualRoute: string): boolean => { 
  if (defineRoute.exact === false) {
    const defineRoutePath = defineRoute.path as string;
    return actualRoute.startsWith(defineRoutePath);
  } else {
    return defineRoute.path === actualRoute;
  }
}

